const translation = {
  tags: {
    design: 'Disegno',
    education: 'Educazione',
    search: 'Ricerca',
    entertainment: 'Divertimento',
    agent: 'Agente',
    image: 'Immagine',
    weather: 'Tempo',
    business: 'Azienda',
    news: 'Notizie',
    other: 'Altro',
    travel: 'Viaggio',
    medical: 'Medico',
    utilities: 'Utilità',
    videos: 'Video',
    productivity: 'Produttività',
    finance: 'Finanza',
    social: 'Sociale',
  },
  searchTags: 'Cerca Tag',
  allTags: 'Tutti i tag',
}

export default translation
